import {
  FETCH_BANK_TXN_ACCOUNTS_REQUEST,
  FETCH_BANK_TXN_ACCOUNTS_SUCCESS,
  FETCH_BANK_TXN_ACCOUNTS_FAILURE,
  FETCH_BANK_TRANSACTIONS_REQUEST,
  FETCH_BANK_TRANSACTIONS_SUCCESS,
  FETCH_BANK_TRANSACTIONS_FAILURE,
  FETCH_BANK_TXN_CHART_REQUEST,
  FETCH_BANK_TXN_CHART_SUCCESS,
  FETCH_BANK_TXN_CHART_FAILURE,
  FETCH_BANK_TXN_EXPORT_REQUEST,
  FETCH_BANK_TXN_EXPORT_SUCCESS,
  FETCH_BANK_TXN_EXPORT_FAILURE
} from '../../Action/BankAction/BankTransactionAction';

const initialState = {
  accounts: [],
  accountsLoading: false,
  accountsError: null,

  // Main transaction history
  transactions: [],
  pagination: {
    total: 0,
    limit: 20,
    offset: 0,
    has_more: false
  },
  summary: {
    total_transactions: 0,
    total_credits: 0,
    total_debits: 0,
    net_movement: 0
  },
  bank_account: null,
  opening_balance: 0,
  closing_balance: 0,
  period: null,
  transactionsLoading: false,
  transactionsError: null,

  // Chart data
  chartData: [],
  chartLoading: false,
  chartError: null,

  // Export
  exportData: [],
  exportLoading: false,
  exportError: null
};

const BankTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Accounts ──────────────────────────────────────────────────────────────
    case FETCH_BANK_TXN_ACCOUNTS_REQUEST:
      return { ...state, accountsLoading: true, accountsError: null };

    case FETCH_BANK_TXN_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accountsLoading: false,
        accounts: action.payload || []
      };

    case FETCH_BANK_TXN_ACCOUNTS_FAILURE:
      return { ...state, accountsLoading: false, accountsError: action.payload };

    // ── Transactions ──────────────────────────────────────────────────────────
    case FETCH_BANK_TRANSACTIONS_REQUEST:
      return { ...state, transactionsLoading: true, transactionsError: null };

    case FETCH_BANK_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionsLoading: false,
        transactions: action.payload?.transactions || [],
        pagination: action.payload?.pagination || initialState.pagination,
        summary: action.payload?.summary || initialState.summary,
        bank_account: action.payload?.bank_account || null,
        opening_balance: action.payload?.opening_balance || 0,
        closing_balance: action.payload?.closing_balance || 0,
        period: action.payload?.period || null
      };

    case FETCH_BANK_TRANSACTIONS_FAILURE:
      return { ...state, transactionsLoading: false, transactionsError: action.payload };

    // ── Chart ─────────────────────────────────────────────────────────────────
    case FETCH_BANK_TXN_CHART_REQUEST:
      return { ...state, chartLoading: true, chartError: null };

    case FETCH_BANK_TXN_CHART_SUCCESS:
      return { ...state, chartLoading: false, chartData: action.payload || [] };

    case FETCH_BANK_TXN_CHART_FAILURE:
      return { ...state, chartLoading: false, chartError: action.payload };

    // ── Export ────────────────────────────────────────────────────────────────
    case FETCH_BANK_TXN_EXPORT_REQUEST:
      return { ...state, exportLoading: true, exportError: null };

    case FETCH_BANK_TXN_EXPORT_SUCCESS:
      return { ...state, exportLoading: false, exportData: action.payload || [] };

    case FETCH_BANK_TXN_EXPORT_FAILURE:
      return { ...state, exportLoading: false, exportError: action.payload };

    default:
      return state;
  }
};

export default BankTransactionReducer;
